import { render, staticRenderFns } from "./aiStudentFull.vue?vue&type=template&id=4a0934a5&"
import script from "./aiStudentFull.vue?vue&type=script&lang=js&"
export * from "./aiStudentFull.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports